import http from "./httpServ";
import axios from "axios";
import moment from "moment";
// import moment from 'moment'
import cache from "./cacheServ";
import mintUi from "../lib/mint-ui";
// let redirectUrl ='http://wap.aigehui028.com/static/rediurl.html?qrcode='
let state = window.location.href.includes("testing-bedoa")
  ? "testing-bedoa"
  : window.location.href.includes("testing")
  ? "testing"
  : "STATE";
console.log(
  "state=",
  state,
  " window.location.origin=",
  window.location.origin
);
let redirectUrl =
  window.location.origin + "/static/rediurl.html?state=" + state + "&qrcode=";
var appid = "wx8ca402d3c3bd00dc";
let wxUrl =
  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8ca402d3c3bd00dc&redirect_uri=${}&response_type=code&scope=snsapi_userinfo&state=" +
  state +
  "#wechat_redirect";
if (window.location.origin.indexOf("tswap") > -1) {
  appid = "wx8ca402d3c3bd00dc";
  console.log("测试");
  wxUrl =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8ca402d3c3bd00dc&redirect_uri=${}&response_type=code&scope=snsapi_userinfo&state=" +
    state +
    "#wechat_redirect";
}

class WxServ {
  /**
   * 获取微信code
   *
   * @param {number} [type=0] 0 快速登录 1 注册 2 验证码登录
   * @memberof WxServ
   */
  getCode() {
    let qrcode = this.GetQueryString("qrcode");
    let bedNo = this.GetQueryString("bedNo");
    let url = wxUrl.replace(
      "${}",
      encodeURIComponent(
        redirectUrl + qrcode + (bedNo ? "&bedNo=" + bedNo : "")
      )
    );
    window.location.replace(url);
  }

  GetQueryString(name) {
    var after = window.location.hash.split("?")[1];
    console.log(after);
    if (after) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = after.match(reg);
    }
    if (r != null) return unescape(r[2]);
    return null;
  }

  /**
   * 微信支付（租借轮椅位）
   *
   * @param {any} userId
   * @param {number} [money=0.01]
   * @returns
   * @memberof WxServ
   */
  prepareWx(bedNO, customerOpenId, orderMoney, qrCode) {
    return http.post(
      "lease/wx/placeAnOrder",
      {},
      {
        data: {
          bedNO,
          customerOpenId,
          orderMoney,
          qrCode
        }
      }
    );
  }

  /**
   * 查询微信支付是否成功
   * @param orderId
   * @returns {AxiosPromise}
   */
  getPayIsSuccess(orderId) {
    return http.post(`lease/queryOrderStatusByWx?orderNo=${orderId}`);
  }
  //获取微信jssdk
  configJssdk(customerOpenId) {
    if (window.location.href.includes("testing"))
      axios.post(
        "https://tswap.aigehui028.com/api/v2/logging",
        JSON.stringify({
          content: {
            ts: moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS"),
            a: "configJssdk",
            contents: {
              url: window.location.href,
              url2Sign: location.href.split("#")[0]
            }
          }
        })
      );
    return http
      .post(
        `wx/zff/queryWxConfig?code=${customerOpenId}&url2Sign=${
          location.href.split("#")[0]
        }`
      )
      .then(res => {
        if (res.code == "200") {
          let config = {
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["openBusinessView"]
          };
          /* eslint-disable no-undef */
          console.log("配置微信", config);
          wx.config(config);
          console.log("配置微信config之后", config);
          // alert('配置微信config之后'+JSON.stringify(config))
          return new Promise((resolve, reject) => {
            wx.ready(resolve);
            wx.error(reject);
          });
        }
      });
  }
  /*
    查询订单信息
     */
  getOrderRefund(customerOpenId, orderN0) {
    //
    return http.post(
      `lease/queryRefundOrderInfo?customerOpenId=${customerOpenId}&orderNo=${orderN0}`
    );
  }

  postZfbPay(qrCode, id) {
    return http.post(`lease/queryOrderStatusByWx?qrCode=${qrCode}`);
  }
  /* 获取广告*/
  getBanner(position) {
    return http.post(`lease/queryAdvByPosition?position=${position}`);
  }

  // 微信免押租借
  getFreeLeaseOrder(openId, qrCode, bedNO) {
    if (window.location.href.includes("testing"))
      axios.post(
        "https://tswap.aigehui028.com/api/v2/logging",
        JSON.stringify({
          content: {
            ts: moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS"),
            a: "createFreeLeaseOrder",
            contents: {
              openId,
              qrCode,
              bedNO
            }
          }
        })
      );
    return http.post(
      `wx/zff/createFreeLeaseOrder`,
      {},
      {
        data: {
          openId,
          qrCode,
          bedNO
        }
      }
    );
  }
}

export default new WxServ();



// WEBPACK FOOTER //
// ./src/service/wxServ.js